// extracted by mini-css-extract-plugin
export default {"about-us-page":"AboutUsPage_about-us-page__C9Bfj"};